import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, SadieVoiceBundle } from "@/types";

/** Sadie voice v1 filled for one fake caller. Read only. */
export function useGetSadieVoiceBundle({
  caller,
  enabled,
  knownCaller,
  pitch,
}: {
  caller: string | undefined;
  enabled: boolean;
  knownCaller: boolean;
  pitch: boolean;
}) {
  return useQuery({
    queryKey: ["sadie-voice-bundle", caller ?? null, knownCaller, pitch],
    queryFn: async () => {
      const res = await guacHttpClient.get<
        SadieVoiceBundle,
        HttpResponse<SadieVoiceBundle>
      >("relationships/simulate/voice/sadie", {
        params: {
          ...(caller ? { caller } : undefined),
          knownCaller,
          pitch,
        },
      });
      return res.data;
    },
    enabled,
    // Filled from fixtures in code. The current time in N01 is fixed at the
    // fetch, which is close enough for a simulated call.
    staleTime: Infinity,
  });
}
